import { supabase } from '@/integrations/supabase/client';
import type { IAnalyticsPort } from '../ports/analytics.port';
import type { ShareLink } from '../types/sharedAnalytics.types';

type RpcClient = {
  rpc: <T>(fn: string, args?: Record<string, unknown>) => Promise<{ data: T | null; error: Error | null }>;
};

const rpcClient = supabase as unknown as RpcClient;

const firstShareLink = (data: ShareLink[] | ShareLink | null): ShareLink | null => {
  if (!data) return null;
  return Array.isArray(data) ? data[0] ?? null : data;
};

export class AnalyticsRepository implements IAnalyticsPort {
  async getCampaignShareLink(campaignId: string): Promise<ShareLink | null> {
    const { data, error } = await rpcClient.rpc<ShareLink[]>('get_campaign_share_link', {
      p_campaign_id: campaignId,
    });

    if (error) {
      console.error('Error fetching campaign share link:', error);
      throw error;
    }

    return firstShareLink(data);
  }

  async createShareLink(campaignId: string): Promise<ShareLink> {
    const { data, error } = await rpcClient.rpc<ShareLink[]>('create_share_link', {
      p_campaign_id: campaignId,
    });

    if (error) {
      console.error('Error creating campaign share link:', error);
      throw error;
    }

    const shareLink = firstShareLink(data);
    if (!shareLink) {
      throw new Error('Share link was not returned by the server.');
    }

    return shareLink;
  }

  async revokeShareLink(token: string): Promise<boolean> {
    const { data, error } = await rpcClient.rpc<boolean>('revoke_share_link', {
      p_token: token,
    });

    if (error) {
      console.error('Error revoking share link:', error);
      throw error;
    }

    return data ?? false;
  }
}


export const analyticsRepository = new AnalyticsRepository();
